import React from 'react';
import { LightbulbIcon, LayersIcon, UsbIcon, HandIcon, PackageIcon, BatteryFullIcon, GlassesIcon } from 'lucide-react';
import { details, Detail, media } from '../data/product';
import { GuaranteeBadge, GuaranteeStrip, ShopHotspot } from './BannerOverlays';
const icons: Record<Detail['icon'], React.ComponentType<{
  className?: string;
}>> = {
  lightbulb: LightbulbIcon,
  layers: LayersIcon,
  usb: UsbIcon,
  hands: HandIcon,
  box: PackageIcon,
  battery: BatteryFullIcon,
  glasses: GlassesIcon
};
export function DetailSection() {
  return <section id="details" className="border-b border-white/10 bg-ink-950" data-id="element-156" data-mp="e58a96guzwg4">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-157" data-mp="94aqwqk44wd1">
        <h2 className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-158" data-mp="45zj0lddovxg">
          Everything you need.
          <br data-id="element-159" data-mp="1yipcj1zu434b" />
          <span className="text-grit-500" data-id="element-160" data-mp="1yi7atpuekwp0">Nothing you don&apos;t.</span>
        </h2>

        <ul className="mt-10 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-161" data-mp="25jkzzyl4a7wv">
          {details.map(detail => {
          const Icon = icons[detail.icon];
          return <li key={detail.title} className="flex h-full flex-col bg-ink-950 p-6" data-id="element-162" data-mp="1vl58vvm3aynd">
                <Icon className="h-7 w-7 text-grit-500" aria-hidden="true" data-id="element-163" data-mp="1vnhz0w204fbi" />
                <h3 className="mt-5 font-display text-2xl font-bold uppercase leading-tight text-offwhite" data-id="element-164" data-mp="20kqg0tbeydb6">
                  {detail.title}
                </h3>
                <p className="mt-2 text-[15px] text-steel-400" data-id="element-165" data-mp="2t95jcil6n76o">{detail.body}</p>
              </li>;
        })}
        </ul>

        <figure id="how" className="relative mt-10 scroll-mt-24" data-id="element-166" data-mp="2ejgdia25af02">
          <img src={media.detailSheet} alt="Detail view of the GritVue X1 frame, light module, lenses and charging port" className="block h-auto w-full border border-white/10" data-id="element-167" data-mp="2jiawbc0443k6" />
          <GuaranteeBadge box={{
          left: '17.2%',
          top: '37.4%',
          width: '17.4%',
          height: '9.2%'
        }} data-id="element-168" data-mp="3c0yd4f82swfg" />
          <ShopHotspot box={{
          left: '3.3%',
          top: '38.4%',
          width: '14.2%',
          height: '7%'
        }} data-id="element-169" data-mp="3luu6bor7nt7n" />
          <GuaranteeStrip data-id="element-170" data-mp="3gxkl6lauu3pm" />
        </figure>
      </div>
    </section>;
}